import { createFileRoute } from '@tanstack/react-router'
import $ from '../App.css'

export const Route = createFileRoute('/')({
  component: HomePage
})

function HomePage() {
  return (
    <>
      <section className={$.hero}>
        <div className={$.container}>
          <h1>Умные&nbsp;решения для&nbsp;вашего бизнеса</h1>
        </div>
      </section>
    </>
  )
}
